export default __webpack_public_path__ + "static/media/anne.15095c8e.jpeg";